var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{'loading' : !_vm.loaded},attrs:{"id":"app"}},[(_vm.$router.currentRoute.fullPath === '/')?_c('main-navigation'):_vm._e(),_c('loader-full',{on:{"hasLoaded":_vm.hasLoaded}}),_c('router-view'),_c('cookie-notice')],1)}
var staticRenderFns = []

export { render, staticRenderFns }